module.exports = __webpack_public_path__ + "static/media/Marker Felt-01.b4d64e5e.svg";